import React from "react";
import Reks_prc from "../Ciselniky_prc/Reks_prc";

const App = ({ className }) => {
  return <Reks_prc />;
};
export default App;
